export default function Loading() {
  return (
    <div className="flex flex-col items-center justify-center min-h-[200px] gap-4">
      {/* Spinner simple et élégant */}
      <div className="w-12 h-12 border-4 border-primary/20 border-t-primary rounded-full animate-spin"></div>
      <p className="text-sm text-gray-500 animate-pulse">Chargement...</p>
    </div>
  );
}

